/*
 * Public API Surface of property-sets
 */
export * from './lib/index';
